module.exports = __webpack_public_path__ + "img/alert-selector-bell.a5a31848.svg";